import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loadding from "../../components/common/loadding";
import { Path } from "../../constants/enum/path.emum";
import scheduleService from "../../services/schedule.service";

const ReportDashboard = () => {
  const [schedule, setSchedule] = useState([]);
  const [status, setStatus] = useState(true);

  useEffect(() => {
    (async () => {
      //ดึงข้อมูลกำหนดการทั้งหมดมา โดยเรียงจาก เปิดไว้บน
      await scheduleService.getAll().then((res) => {
        setSchedule(res.data);
        setStatus(false);
      });
    })();
  }, []);

  if (status) {
    return <Loadding />;
  }
  return (
    <>
      <div className="container">
        <h3 className="text-start mt-3">รายงาน</h3>
        <div className="row mt-3">
          <div className="col">
            {/* <h3 className="p-3 mb-4 bg-light rounded-4">
              <div className="row">
                <div className="col">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ค้นหา"
                    aria-label="ค้นหา"
                  />
                </div>
              </div>
            </h3> */}
            <h5 className="text-start mt-3">รายการกำหนดการทั้งหมด</h5>
            <table className="table table-hover table-responsive">
              <thead className="table-dark">
                <tr>
                  <th>ปีการศึกษา</th>
                  <th>ภาคการศึกษา</th>
                  <th>ประเภทเอกสาร</th>
                  <th>ส่ง มคอ.|อชว.3 R-1</th>
                  <th>ส่ง มคอ.|อชว.5 R-2</th>
                  <th>สถานะ</th>
                  <th>Handle</th>
                </tr>
              </thead>
              <tbody>
                {schedule.map((schedule: any) => {
                  return (
                    <tr key={schedule.id}>
                      <th scope="row">{schedule.year}</th>
                      <td>{schedule.term}</td>
                      <td>
                        {schedule.type === "tqf" ? "มคอ." : "อชว."} | RMUTI
                      </td>
                      <td>
                        {moment(schedule.doc3)
                          .add(543, "year")
                          .format("DD/MM/yyyy")}
                      </td>
                      <td>
                        {moment(schedule.doc5)
                          .add(543, "year")
                          .format("DD/MM/yyyy")}
                      </td>
                      <td>{schedule.status ? "เปิด" : "ไม่เปิด"}รับเอกสาร</td>
                      <td>
                        <Link
                          to={`${Path.REPORT}/${schedule.id}`}
                          type="button"
                          // className="btn btn-sm btn-outline-warning"
                          className="btn btn-sm btn-warning"
                        >
                          <i className="bi bi-file-earmark-text-fill"></i>{" "}
                          รายงานการส่งเอกสาร
                        </Link>{" "}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportDashboard;
